import React, { Fragment } from 'react';
import { Box, Flex } from '@marvelapp/ui';
import { SpecsPanel, SpecsPanelProperty } from '@marvelapp/ui-internal';
import Measurement from '../../containers/handoff/Measurement';
import PanelFormatSettings from '../../containers/handoff/PanelFormatSettings';
import Fills from './sidebar/Fills';
export default function PanelArtboard(_a) {
    var width = _a.width, height = _a.height, fills = _a.fills;
    return (React.createElement(Fragment, null,
        React.createElement(SpecsPanel, { title: "Properties" },
            React.createElement(Flex, null,
                React.createElement(Box, { width: 1 / 4 },
                    React.createElement(SpecsPanelProperty, { label: "Width" },
                        React.createElement(Measurement, { value: width }))),
                React.createElement(Box, { width: 1 / 4 },
                    React.createElement(SpecsPanelProperty, { label: "Height" },
                        React.createElement(Measurement, { value: height }))))),
        React.createElement(Fills, { "data-testid": "item-fills", fills: fills }),
        React.createElement(SpecsPanel, { title: "Format Settings" },
            React.createElement(PanelFormatSettings, null))));
}
